import { actFormTypeIds } from '../models/actFormTypeIds';
import { orderTypeIds } from '../models/orderTypeIds';

export const GOVERNMENT_ACT_ONLY_EXTRA_FILTER = {
    orderType: {
        operand1: orderTypeIds.government,
        operator: 1,
    },
    form: {
        type: {
            operand1: actFormTypeIds.act,
            operator: 'equals',
        },
    },
};

export function getActFormType(record) {
    return Number(
        record?.form?.type ??
        record?.form?.typeId ??
        record?.form?.Type ??
        record?.form?.TypeId ??
        record?.formType ??
        record?.formTypeId ??
        record?.FormType ??
        record?.FormTypeId ??
        0
    );
}

export function isDirectionDocument(record) {
    if (!record) {
        return false;
    }

    if (getActFormType(record) === actFormTypeIds.direction) {
        return true;
    }

    const number = record.number ?? record.form?.number ?? '';
    return typeof number === 'string' && number.startsWith('Direction');
}

export function isGovernmentAct(record) {
    if (!record || isDirectionDocument(record)) {
        return false;
    }

    const formType = getActFormType(record);
    if (formType === actFormTypeIds.direction) {
        return false;
    }
    if (formType && formType !== actFormTypeIds.act) {
        return false;
    }

    const orderType = Number(record.orderType ?? record.OrderType ?? 0);
    return orderType === orderTypeIds.government;
}

/** К постановлению: акты госзаказа и направления. */
export function isEligibleForResolutionAttachment(record) {
    if (!record) {
        return false;
    }
    if (isDirectionDocument(record)) {
        return true;
    }
    if (isGovernmentAct(record)) {
        return true;
    }
    // Уже прикреплённые строки часто приходят без form/orderType — не блокируем сохранение
    const formType = getActFormType(record);
    if (!formType && record.form == null) {
        return true;
    }
    return false;
}

/** Фильтр списка: госзаказ (акты и направления), без отсечения направлений. */
export const RESOLUTION_ATTACHMENT_EXTRA_FILTER = {
    orderType: {
        operand1: orderTypeIds.government,
        operator: 1,
    },
};
